import styled, { keyframes, css } from 'styled-components';
import React, { useState } from 'react';
import ActionButton from '@westwing/ui-kit/ActionButton';
import { fromBreakpoint, TABLET } from '../../mediaqueries';
import useExternalInterface from 'SharedHooks/useExternalInterface';
import Spinner from 'SharedComponents/Spinner';

export interface SubmitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading: boolean;
    buttonText: string;
    addWiggleEffect: boolean;
}

const wiggleEffect = keyframes`
    0% {transform: rotate(0deg);}

    1% {transform: rotate(-1deg);}
    2% {transform: rotate(1deg);}

    3% {transform: rotate(-1deg);}
    4% {transform: rotate(1deg);}

    5% {transform: rotate(0);}
    100% {transform: rotate(0);}
`;

const SubmitButtonWrapper = styled(ActionButton)<{ $addWiggleEffect: boolean; $forceWiggleEffect: boolean }>`
    display: block;
    font-family: ${props => props.theme?.loginRegisterForm?.submitButton?.fontFamily ?? 'Brandon Grotesque Regular'};
    font-size: 0.875em;
    line-height: 1;
    letter-spacing: 0.021875em;
    cursor: pointer;
    margin: ${props => props.theme?.loginRegisterForm?.submitButton?.margin ?? '1.25em 0 0'};
    animation: ${props =>
        props.$addWiggleEffect || props.$forceWiggleEffect
            ? css`
                  ${wiggleEffect} ${props.$forceWiggleEffect
                      ? '1s cubic-bezier(0.86, 0, 0.07, 1) 0s 1 running'
                      : '7s cubic-bezier(0.86, 0, 0.07, 1) 6s infinite running'};
              `
            : ''};

    &:disabled {
        cursor: default;
    }

    ${props => fromBreakpoint[TABLET]`
        font-size: ${props.theme?.loginRegisterForm?.submitButton?.desktopFontSize ?? '1em'};       
    `}
`;

const SubmitButton: React.FunctionComponent<SubmitButtonProps> = props => {
    const [forceWiggleEffect, setForceWiggleEffect] = useState(false);
    const { name, type, isLoading, onClick, addWiggleEffect, className, buttonText } = props;

    useExternalInterface({
        name: 'signupCtaButtonApi',
        methods: {
            forceCtaWiggle: () => setForceWiggleEffect(true),
        },
    });

    return (
        <SubmitButtonWrapper
            name={name ?? ''}
            type={type ?? 'submit'}
            kind="primary"
            disabled={isLoading}
            onClick={onClick}
            $addWiggleEffect={addWiggleEffect}
            $forceWiggleEffect={forceWiggleEffect}
            className={className}
            onAnimationEnd={() => {
                setForceWiggleEffect(false);
            }}
        >
            {isLoading ? <Spinner /> : buttonText}
        </SubmitButtonWrapper>
    );
};

export default SubmitButton;
